import { Horizontal, Texto, Vertical } from '@gravitate-js/excalibrr'
import { theme } from 'antd'
import { format } from 'date-fns'
import * as React from 'react'
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip } from 'recharts'

import { useLaunchpadContext } from '../context'
import { MetricCard } from './MetricCard'
import { CostRevenueSelector } from './common/CostRevenueSelector'

/**
 * Component that displays invoice throughput metrics and chart
 */
export function InvoiceThroughput() {
  const { data, costRevenue, setCostRevenue } = useLaunchpadContext()
  const { token } = theme.useToken()

  if (!data) {
    return null
  }

  const { dailyThroughput, mtdSummary } = data

  return (
    <Vertical bg='default' border='all' borderRadius='6px' gap={16} flex={3} className='pt-3'>
      <Horizontal flex='0' style={{ overflow: 'visible', width: '100%' }} verticalCenter className='px-3'>
        <Texto style={{ flex: 1, whiteSpace: 'nowrap' }} category='p2' appearance='hint' weight='600'>
          Invoice Throughput
        </Texto>
        <Horizontal flex='0' style={{ overflow: 'visible' }} verticalCenter className='pr-3'>
          <CostRevenueSelector value={costRevenue} onChange={setCostRevenue} />
        </Horizontal>
      </Horizontal>

      <Horizontal bg='default' gap={16} flex={3}>
        <Vertical className='pl-3 py-3' flex={1}>
          <div style={{ height: 220 }}>
            <ResponsiveContainer>
              <BarChart data={dailyThroughput}>
                <CartesianGrid strokeDasharray='3 3' vertical={false} />
                <Tooltip
                  formatter={(value: number | null, name: string) => {
                    if (value === null) return [0, name.charAt(0).toUpperCase() + name.slice(1)]
                    return [value, name.charAt(0).toUpperCase() + name.slice(1)]
                  }}
                  labelFormatter={(_, payload) => {
                    if (payload?.[0]) {
                      const { fullDate } = payload[0].payload
                      return format(fullDate, 'MMMM d, yyyy')
                    }
                    return ''
                  }}
                />
                <Bar dataKey='sent' stackId='a' fill={token.colorPrimary} />
                <Bar dataKey='ready' stackId='a' fill={token.colorInfo} />
                <Bar dataKey='open' stackId='a' fill={token.colorInfoActive} />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </Vertical>

        <Vertical
          flex='0'
          style={{ overflow: 'visible', minWidth: 'fit-content' }}
          gap={24}
          className='pr-3'
          verticalCenter
        >
          <MetricCard
            title='Sent MTD'
            amount={mtdSummary.sent.amount}
            metrics={[
              {
                label: `${mtdSummary.sent.orderCount} Orders`,
                value: '',
                type: 'freight_line_items',
                status: 'posted',
                linkLabel: 'View sent order line items',
              },
              {
                label: `${mtdSummary.sent.invoiceCount} Invoices`,
                value: '',
                type: 'invoices',
                status: 'sent',
                linkLabel: 'View sent invoices',
              },
            ]}
          />

          <MetricCard
            title='Open'
            amount={mtdSummary.open.amount}
            isOpen
            metrics={[
              {
                label: `${mtdSummary.open.orderCount} Orders`,
                value: '',
                type: 'freight_line_items',
                status: 'open',
                linkLabel: 'View open order line items',
              },
              {
                label: `${mtdSummary.open.invoiceCount} Invoices`,
                value: '',
                type: 'invoices',
                status: 'open',
                linkLabel: 'View open invoices',
              },
            ]}
          />
        </Vertical>
      </Horizontal>
    </Vertical>
  )
}
